module.exports = __webpack_public_path__ + "./RogerPhoto_2f2ee45108f291066ce82d997d215d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/RogerPhoto.png
// module id = 541
// module chunks = 0